//#region src/assets/hn-flag.svg
var hn_flag_default = "" + new URL("hn-flag-C7i-Z8uO.svg", import.meta.url).href;
//#endregion
export { hn_flag_default as default };

//# sourceMappingURL=hn-flag.js.map